// extracted by mini-css-extract-plugin
module.exports = {"container":"container--c4-QY","message":"message--1rVOK"};